import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { ButtonBase } from '#src/atoms/buttons/ButtonBase/index.tsx';
import { Vertical } from '#src/atoms/layout/flex/index.tsx';
import type { CreateFiatWalletSteps } from '#src/components/fiatWallet/CreateFiatWallet/type.ts';
import { useBackButtonTargets } from '#src/components/fiatWallet/CreateFiatWallet/useBackButtonTargets.ts';
import { glossary } from '#src/lib/glossary.ts';

const Root = styled.div`
  flex-grow: 1;
  align-items: flex-end;
  display: flex;
  justify-content: space-between;
  flex-direction: row-reverse;
`;

const Content = styled(Vertical).attrs({ gap: 2 })`
  min-height: 100%;
`;
const StyledButtonBase = styled(ButtonBase)`
  text-decoration: underline;
`;

type StepWrapperFromPropsProps = {
  children: ReactNode;
  onBack?: () => void;
  submitButton: ReactNode;
};

export const StepWrapperFromProps = ({
  children,
  onBack,
  submitButton,
}: StepWrapperFromPropsProps) => {
  return (
    <Content>
      {children}
      <Root>
        {submitButton}
        {!!onBack && (
          <StyledButtonBase onClick={onBack}>
            <FormattedMessage {...glossary.back} />
          </StyledButtonBase>
        )}
      </Root>
    </Content>
  );
};

type Props = {
  step: CreateFiatWalletSteps;
  setStep: (step: CreateFiatWalletSteps) => void;
} & Omit<StepWrapperFromPropsProps, 'onBack'>;

export const StepWrapper = ({
  children,
  step,
  setStep,
  submitButton,
}: Props) => {
  const backTargets = useBackButtonTargets({});
  const backTarget = backTargets[step];
  return (
    <StepWrapperFromProps
      submitButton={submitButton}
      onBack={
        backTarget
          ? () => {
              setStep(backTarget);
            }
          : undefined
      }
    >
      {children}
    </StepWrapperFromProps>
  );
};
